import React from 'react'

export default function Footer() {
  return (
    <div className="text-white p-4 text-xs flex justify-center">
        All rights reserved <a href="https://www.brianjkim.dev" target="_blank" rel="noreferrer">brianjkim</a>
    </div>
  )
}
